import {Component, Input, OnInit} from '@angular/core';
import {SessionService} from '../core/service/session.service';
import {CommonService} from '../core/service/common.service';
import {MasterService} from '../core/service/master.service';
import {HomeService} from '../core/service/home.service';
import {AlertService} from '../core/service/alert.service';
import {
  COLLECTION_NAME,
  ABNORMAL_PROPERTIES,
  TAIOU_PROPERTIES,
  KEISHA_HIBETSU_FILE_GAIKION,
  SEIJOU,
  GENZAI_WASUU,
  TEISEI_WASUU,
  HEISHI_WASUU,
  TOUTA_WASUU, NYUUKA_WASUU, SHUKKA_WASUU, KEISHAHIBETSUFILE_PROPERTY
} from '../shared/constants';
import {AngularFirestore} from '@angular/fire/firestore';
import {MessageService} from '../core/service/message.service';
import {ShiyoulotService} from '../core/service/shiyoulot.service';
import {Feed, Feed2} from '../shared/interfaces/feed';
import {ActivatedRoute} from '@angular/router';
import {Mutable, WithNullable, yyyyMMdd} from '../shared/typeAliases';
import {KeishaHibetsuFile} from '../shared/interfaces/keisha-hibetsu-file';
import {
  genFeedDefaultValue,
  genTentouDefaultValue,
  getInitKeishaHibetsuFile,
  KeishaHibetsuFileService, setOperatorList
} from '../core/service/keisha-hibetsu-file.service';
import {Keisha} from '../shared/interfaces/keisha';
import {TentouShoutouJikoku} from '../shared/interfaces/tentou';
import {firstValueFrom} from 'rxjs';
import {
  SagyouKirokuCsvExportDialogComponent
} from '../shared/dialog/sagyou-kiroku-csv-export-dialog/sagyou-kiroku-csv-export-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-keisha-meisai',
  templateUrl: './keisha-meisai.component.html',
  styleUrls: ['./../shared/layout/layout.component.scss', './keisha-meisai.component.scss', './../shiyoulot/shiyoulot-meisai/shiyoulot-meisai.component.scss']
})
export class KeishaMeisaiComponent implements OnInit {
  @Input() modal = false;
  selectedKeisha: Keisha;
  selectedHibetsuDate: yyyyMMdd = this.commonService.getDateWithString();
  selectedKeishaHibetsuFile: WithNullable<KeishaHibetsuFile, 'feed'>;
  abnormalProperties = ABNORMAL_PROPERTIES;
  abnormalKeys = this.commonService.keysOf(this.abnormalProperties);
  taiouProperties = TAIOU_PROPERTIES;
  taiouKeys = this.commonService.keysOf(this.taiouProperties);
  isAbnormalState = false;
  meisaiTabNames = ['温度', '餌・水', '点灯', '異常', '作業'] as const;
  gaikionProperties = KEISHA_HIBETSU_FILE_GAIKION;
  meisaiTabIndex = 0;
  keishaFloorArray: number[] = [];
  feedTankArray: number[] = [];
  feedTankObjList: {ton: number, kg: number}[] = []; // ex. {ton: 1, kg: 1000}
  feedShubetsuList: Feed[] | Feed2[] = [];
  prevTentouShoutouJikan: TentouShoutouJikoku[] = genTentouDefaultValue();
  tentouJikan = {prevTentouJikan: '', tentouJikan: '', warikomiTentouJikan: ''};

  constructor(public masterService: MasterService,
              public homeService: HomeService,
              public alertService: AlertService,
              public sessionService: SessionService,
              public commonService: CommonService,
              public db: AngularFirestore,
              private activatedRoute: ActivatedRoute,
              private messageService: MessageService,
              public shiyoulotService: ShiyoulotService,
              public keishaHibetsuFileService: KeishaHibetsuFileService,
              private dialog: MatDialog,
  ) {
    // shozokuKeishaIdに一致する鶏舎が必ず存在するはずなので、castする
    this.selectedKeisha = this.masterService.keishaMaster.find(keisha => {
      return keisha.id === this.sessionService.session.personalSetting?.shozokuKeishaId;
    })!;

    // URLのparameterで指定されている値があれば、それで上書きする
    this.setInitialValueFromParameter();
    // とりあえず仮の値を入れておく
    this.selectedKeishaHibetsuFile = this.keishaHibetsuFileService.getInitKeishaHibetsuFile(this.selectedKeisha?.id ?? '', this.selectedHibetsuDate);
  }

  /**
   *
   */
  async ngOnInit(): Promise<void> {
    if (this.selectedKeisha?.id) {
      this.selectedKeishaHibetsuFile = await this.getKeishaHibetsuFile(this.selectedKeisha.id, this.selectedHibetsuDate);
      console.log('this.selectedKeishaHibetsuFile', this.selectedKeishaHibetsuFile);
      this.init();
    }
    // this.setKeishaHibetsuValuesWithBatch('2022-05-19', '2022-05-25');
  }

  /**
   * URLのパラメータで指定された値があれば初期値としてセット
   * @private
   */
  private setInitialValueFromParameter() {
    const paramId = this.activatedRoute.snapshot.paramMap.get('id');
    const paramDate = this.activatedRoute.snapshot.paramMap.get('date');
    if (paramId) {
      const keisha = this.masterService.keishaMaster.find(keisha => {
        return keisha.id === paramId;
      });
      if (keisha) {
        this.selectedKeisha = keisha;
      }
    }
    if (paramDate) {
      this.selectedHibetsuDate = paramDate;
    }
  }

  /**
   * 新しく鶏舎日別ファイルを取得した後の初期化処理
   * @param changed
   */
  init(changed: 'keisha'| 'date' = 'keisha') {
    // 鶏舎日別ファイルで餌が未登録の場合,feedShubetsuをnullセット。
    // 更新時にnullの場合初期値をセット。
    this.feedShubetsuList = this.keishaHibetsuFileService.getFeedList(this.selectedKeisha);
    if (this.selectedKeishaHibetsuFile.tentouShoutouJikoku
      && !this.commonService.objectIsEmpty(this.selectedKeishaHibetsuFile.tentouShoutouJikoku[0])) {
      this.prevTentouShoutouJikan = [{...this.selectedKeishaHibetsuFile.tentouShoutouJikoku[0]}];
    }
    this.resetAllTentouJikan();
    this.updateIsAbnormalState();
    if (changed === 'keisha') {
      this.keishaFloorArray = this.commonService.genSequentialNumber(this.selectedKeisha.layout.floor);
      this.feedTankArray = this.commonService.genSequentialNumber(this.selectedKeisha.feedTankQuantity ? this.selectedKeisha.feedTankQuantity : 1);
      this.feedTankObjList = this.commonService.genFeedTankObjList(this.selectedKeisha);
    }
    // TODO 初回未定義の場合どうするか。「0」にするのか。要確認。
    // TODO: ここではkgの想定で実装。
    this.feedTankArray.forEach(i => {
      this.selectedKeishaHibetsuFile.esaZan['esaZan' + i] = typeof this.selectedKeishaHibetsuFile.esaZan['esaZan' + i] !== 'undefined'
        ? this.selectedKeishaHibetsuFile.esaZan['esaZan' + i] : 0;
    });
    console.log(this.selectedKeishaHibetsuFile);
  }

  /**
   * 割り込み関連の値を初期化
   */
  initWarikomiTentouJikan() {
    this.selectedKeishaHibetsuFile.warikomiTentouShoutouJikoku = genTentouDefaultValue();
    this.tentouJikan.warikomiTentouJikan = '';
    // Viewの更新(割り込み関連の値初期化)後にアラートを表示するため、セットタイムアウト
    setTimeout(() => {
      if (confirm('データを更新しますか?')) {
        this.updateKeishaHibetsuFile();
      }
    }, 100);
  }

  /**
   *
   */
  async onChangeKeisha(): Promise<void> {
    this.selectedKeishaHibetsuFile = await this.getKeishaHibetsuFile(this.selectedKeisha.id, this.selectedHibetsuDate);
    this.init();
  }

  /**
   * 選択された日付に応じた日別ファイルを取得
   * 「shubetsu」を指定することで鶏舎のみ飼養ロットのみ取得も可
   * @param selectedDate
   */
  async selectedDateChange(selectedDate: yyyyMMdd = this.selectedHibetsuDate) {
    this.selectedKeishaHibetsuFile = await this.getKeishaHibetsuFile(this.selectedKeisha.id, selectedDate);
    this.init('date');
  }

  /**
   * 点灯時刻、消灯時刻に合わせ、点灯時間を更新
   * @param tentouShoutouJikoku
   * @param tentouJikanKey
   */
  genTentouJikan(tentouShoutouJikoku: TentouShoutouJikoku[],
    tentouJikanKey: 'prevTentouJikan'| 'tentouJikan' | 'warikomiTentouJikan' = 'tentouJikan') {
    if (tentouShoutouJikoku && tentouShoutouJikoku.length) {
      this.tentouJikan[tentouJikanKey] = this.commonService.genTimeDiffString(tentouShoutouJikoku[0].start, tentouShoutouJikoku[0].end);
    }
  }

  /**
   * 点灯関連の値を全てセットし直す
   */
  resetAllTentouJikan() {
    this.genTentouJikan(this.selectedKeishaHibetsuFile.tentouShoutouJikoku);
    this.genTentouJikan(this.selectedKeishaHibetsuFile.warikomiTentouShoutouJikoku, 'warikomiTentouJikan');
    this.genTentouJikan(this.prevTentouShoutouJikan, 'prevTentouJikan');
  }

  /**
   * 点灯時間に合わせ、消灯時間を更新
   * @param tentouShoutouJikoku
   * @param tentouJikanKey
   */
  refTentouJikanInShoutouJikoku(tentouShoutouJikoku: TentouShoutouJikoku[],
    tentouJikanKey: 'prevTentouJikan'| 'tentouJikan' | 'warikomiTentouJikan' = 'tentouJikan') {
    if (!this.selectedKeishaHibetsuFile) {
      return;
    }
    const exp = /^\d{2}:\d{2}$/g;
    if (tentouShoutouJikoku[0].start.match(exp)) {
      const hourTentouJikoku = Number(tentouShoutouJikoku[0].start.split(':')[0]);
      const minTentouJikoku = Number(tentouShoutouJikoku[0].start.split(':')[1]);
      const hourTentouJikan = Number(this.tentouJikan[tentouJikanKey].split(':')[0]);
      const minTentouJikan = Number(this.tentouJikan[tentouJikanKey].split(':')[1]);
      let shoutouJikokuInMinutes = hourTentouJikoku * 60 + minTentouJikoku + (hourTentouJikan * 60 + minTentouJikan);
      shoutouJikokuInMinutes += 60 * 24;
      shoutouJikokuInMinutes %= 60 * 24;
      tentouShoutouJikoku[0].end = ('0' + Math.floor(shoutouJikokuInMinutes / 60)).slice(-2) + ':' + ('0' + shoutouJikokuInMinutes % 60).slice(-2);
    }
  }

  /**
   * 鶏舎日別ファイルを返す
   * 未生成の場合、新しい鶏舎日別ファイルを作成し、返す
   *
   * @param keishaId
   * @param date
   */
  async getKeishaHibetsuFile(keishaId: string, date: yyyyMMdd) {
    let data: WithNullable<KeishaHibetsuFile, 'feed'> | null = null;
    const keishaHibetsuFiles = await firstValueFrom(this.keishaHibetsuFileService.getKeishaHibetsuFileUpdatedGenzaiWasuu(keishaId, date, date));
    if (!!keishaHibetsuFiles.length) {
      data = this.commonService.updateKeishaHibetsuFileV1ToV2(keishaHibetsuFiles[0]);
    }
    if (!data) {
      data = getInitKeishaHibetsuFile(keishaId, date);
      // operatorListをセット
      setOperatorList(data as KeishaHibetsuFile, this.selectedKeisha.operators);
    }
    // ng-selectの見た目をスッキリさせるため
    if (!data.feed || !data.feed.id) {
      data.feed = null;
    }
    return data;
  }

  /**
   *
   */
  updateIsAbnormalState() {
    this.isAbnormalState = this.keishaHibetsuFileService.checkIsAbnormalState(this.selectedKeishaHibetsuFile);
  }

  /**
   *
   */
  updateKeishaHibetsuFile() {
    const customerId = this.sessionService.session.personalSetting.customerId;
    const keishaId = this.selectedKeishaHibetsuFile.keishaId;
    const id = this.selectedHibetsuDate;
    if (!this.checkWarikomiTentouShoutouJikoku()) {
      alert('割り込み点灯時間に未定義の値があります。');
      return;
    }

    checkTentouShoutouJikoku(this.selectedKeishaHibetsuFile);
    if (this.selectedKeishaHibetsuFile.feed === null) {
      this.selectedKeishaHibetsuFile.feed = genFeedDefaultValue();
    }
    console.log(customerId, keishaId, id);
    if (customerId && keishaId && id) {
      this.selectedKeishaHibetsuFile.timeStamp = new Date();
      this.db.collection(COLLECTION_NAME.CUSTOMERS).doc(customerId)
        .collection(COLLECTION_NAME.KEISHAMASTER).doc(keishaId)
        .collection(COLLECTION_NAME.KEISHAHIBETSUFILE).doc(id)
        .set(this.genKeishaHibetsuFileUpdateObj(this.selectedKeishaHibetsuFile), {merge: true}).then(() => {
          this.messageService.pushInfo('更新しました');
          console.log('document successfully updated!');
        }).catch(e => {
          this.messageService.pushError('更新に失敗しました');
          console.log('failed to updated document: ', e);
        });
    }

    // tentouShoutouJikokuに値が入っているがチェック
    // 入っていなければ「00:00」を入れておく。
    /**
     *
     * @param selectedKeishaHibetsuFile
     */
    function checkTentouShoutouJikoku(selectedKeishaHibetsuFile: WithNullable<KeishaHibetsuFile, 'feed'>) {
      const propertyNames = ['start', 'end'] as const;
      for (const propertyName of propertyNames) {
        if (!selectedKeishaHibetsuFile.tentouShoutouJikoku[0][propertyName]) {
          selectedKeishaHibetsuFile.tentouShoutouJikoku[0][propertyName] = '00:00';
        }
      }
    }
  }

  /**
   * 鶏舎日別ファイルから羽数関連の値を取り除いたobjectを生成
   * 鶏舎明細画面からは羽数関連を変更できないので更新する必要が無い
   * @param keishaHibetsuFile
   */
  genKeishaHibetsuFileUpdateObj(keishaHibetsuFile:  WithNullable<KeishaHibetsuFile, "feed">) {
    const tempKeishaHibetsuFile = {...keishaHibetsuFile};
    const willDeleteProperties: (keyof KeishaHibetsuFile)[]
      = [GENZAI_WASUU, TEISEI_WASUU, HEISHI_WASUU, TOUTA_WASUU];
    willDeleteProperties.forEach(property => {
      if (typeof tempKeishaHibetsuFile[property] != 'undefined') {
        delete tempKeishaHibetsuFile[property];
      }
    });
    return tempKeishaHibetsuFile;
  }

  /**
   * warikomiTentouShoutouJikokuのstart、endの両方に値が入っているかチェック
   */
  checkWarikomiTentouShoutouJikoku() {
    // 両方値がある、もしくは両方値が無い場合、true
    if (!!this.selectedKeishaHibetsuFile.warikomiTentouShoutouJikoku[0].start
      === !!this.selectedKeishaHibetsuFile.warikomiTentouShoutouJikoku[0].end) {
      return true;
    }
    return false;
  }

  /**
   * 異常関連の値が更新されたら、isAbnormalStateを更新する
   * @param selectedKey
   */
  onClickAbnormalProperty(selectedKey: string) {
    if (!this.selectedKeishaHibetsuFile) {
      return;
    }
    this.keishaHibetsuFileService.resetAbnormalProperty(this.selectedKeishaHibetsuFile, selectedKey);
    this.updateIsAbnormalState();
    // 正常以外が全てfalseのとき、正常をtrueに設定
    this.selectedKeishaHibetsuFile[SEIJOU] = !this.isAbnormalState;
  }

  /**
   * デバッグ用のスクリプト
   * 指定した期間の鶏舎日別ファイルの値を
   * 直近の鶏舎日別に書き込む処理（羽数関連の値は更新しない）
   * setKeishaHibetsuValuesWithBatch('2022-05-23', '2022-05-25') →
   * 実行日の鶏舎日別ファイルに2022-05-25の値
   * 実行前日の鶏舎日別ファイルに2022-05-24の値
   * 実行2日前の鶏舎日別ファイルに2022-05-23の値
   * をそれぞれ書き込み。
   * @param fromDate
   * @param toDate
   */
  async setKeishaHibetsuValuesWithBatch(fromDate: yyyyMMdd, toDate: yyyyMMdd) {
    const originDateLabel = this.commonService.genDateStringInTerm(fromDate, toDate);
    let targetDate = this.commonService.getDateWithString();
    // const targetFromDate = this.commonService.genOffsetDateWithStandardDateString(targetDate, -originDateLabel.length);
    // const targetDateLabel = this.commonService.genDateStringInTerm(targetFromDate, targetDate);
    // TODO 鶏舎日別Fの現在羽数を飼養ロットFの現在羽数の合計で置き換える必要がある場合、
    // getKeishaHibetsuFileUpdatedGenzaiWasuuを使用する。
    const keishaHibetsuFileDocs = await this.keishaHibetsuFileService.getKeishaHibetsuFile(this.selectedKeisha.id, fromDate, toDate);
    const keishaHibetsuRef = keishaHibetsuFileDocs.docs[0].ref.parent;
    const keishaHibetsuFiles = this.commonService.sortObjectArray(this.commonService.deleteUndefinedFromArray(keishaHibetsuFileDocs.docs.map(doc => this.commonService.updateKeishaHibetsuFileV1ToV2(doc.data()))), 'id', false) as KeishaHibetsuFile[];
    if (keishaHibetsuFiles.length !== originDateLabel.length) { return; }

    const batch = this.db.firestore.batch();
    for (let i = 0; i < keishaHibetsuFiles.length; i++) {
      const keishaHibetsuFile = keishaHibetsuFiles[i] as Mutable<Partial<KeishaHibetsuFile>>;
      keishaHibetsuFile.id = targetDate;
      delete keishaHibetsuFile.genzaiWasuu;
      delete keishaHibetsuFile.heishiWasuu;
      delete keishaHibetsuFile.toutaWasuu;
      delete keishaHibetsuFile.teiseiWasuu;
      // delete keishaHibetsuFile.nyuukaWasuu;
      // delete keishaHibetsuFile.shukkaWasuu;
      // delete keishaHibetsuFile.todayShiyoulotHeishiTouta;
      console.log(keishaHibetsuFile.id, keishaHibetsuFile);
      batch.set(keishaHibetsuRef.doc(keishaHibetsuFile.id), keishaHibetsuFile, {merge: true});
      targetDate = this.commonService.genOffsetDateWithStandardDateString(targetDate, -1);
    }
    if (confirm('書き込みますか?') && confirm('書き込みますか?')) {
      batch.commit()
        .then(() => console.log('completed.'))
        .catch((e) => console.error(e));
    }
  }

  /**
   * 作業記録のCSV出力ダイアログを開く
   */
  openSagyouKirokuCSVExportDailog() {
    // ダイアログを開く。
    const dialogRef = this.dialog.open<SagyouKirokuCsvExportDialogComponent, string>(SagyouKirokuCsvExportDialogComponent, {
      data: this.selectedKeisha.farmId,
      maxWidth: '30vw',
      minWidth: '30vw',
      height: '30vh',
      panelClass: 'dialog-with-close', // dialog外クリックでdialogを閉じる。
    });

    // CSV出力したら、ダイアログを閉じる。閉じた後の処理はなし。
    return dialogRef.afterClosed();
  }
}

